import React from 'react';
import AuthShell from '@/components/layout/AuthShell';
import WelcomeHero from '@/pages/welcome/WelcomeHero';
import WelcomeFeatureGrid from '@/pages/welcome/WelcomeFeatureGrid';
import WelcomeSources from '@/pages/welcome/WelcomeSources';
import WelcomeHowItWorks from '@/pages/welcome/WelcomeHowItWorks';
import WelcomeFinalCTA from '@/pages/welcome/WelcomeFinalCTA';

// Layout and type for every section live in styles/welcome.css (wl-*).
const Welcome = () => {
  return (
    <AuthShell variant="hero">
      <div className="wl-page">
        <WelcomeHero />
        <WelcomeFeatureGrid />
        <WelcomeSources />
        <WelcomeHowItWorks />
        <WelcomeFinalCTA />
      </div>
    </AuthShell>
  );
};

export default Welcome;
